module.exports = __webpack_public_path__ + "static/media/Archana.f8dc6e28.png";